import flow from 'lodash/flow';
import memoizeOne from 'memoize-one';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { SIMPLE } from '@atlassian/jira-common-directory-v2/src/model/constants.tsx';
import { COPY, DELETE, MOVE } from '@atlassian/jira-directory-base/src/model/operation-types.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import {
	getName,
	isPrivate,
	getType,
	canEdit,
	getEditBoardUrl,
	getLocation,
} from '../../../../state/selectors/boards/index.tsx';
import type { State } from '../../../../state/types.tsx';
import LocationWithTypeActions from './view.tsx';

const mapStateToPropsFactory = () => {
	const onDeleteFactory = memoizeOne(
		(onOperationRequested: EntityCellProps['onOperationRequested']) => () =>
			// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
			onOperationRequested(DELETE),
	);
	const onCopyFactory = memoizeOne(
		(onOperationRequested: EntityCellProps['onOperationRequested']) => () =>
			// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
			onOperationRequested(COPY),
	);
	const onMoveFactory = memoizeOne(
		(onOperationRequested: EntityCellProps['onOperationRequested']) => () =>
			// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
			onOperationRequested(MOVE),
	);
	return (state: State, ownProps: EntityCellProps) => ({
		name: !isPrivate(state, ownProps.id) ? getName(state, ownProps.id) : undefined,
		isPrivate: isPrivate(state, ownProps.id),
		editBoardUrl: getEditBoardUrl(state, ownProps.id),
		onDelete: onDeleteFactory(ownProps.onOperationRequested),
		onCopy: onCopyFactory(ownProps.onOperationRequested),
		onMove: onMoveFactory(ownProps.onOperationRequested),
		showSpinner: ownProps.isOperationInProgress,
		isSimple: !isPrivate(state, ownProps.id) && getType(state, ownProps.id) === SIMPLE,
		canEdit: canEdit(state, ownProps.id),
		location: getLocation(state, ownProps.id),
	});
};

export default flow(
	withFireUiAnalytics({
		onEdit: 'edit',
		onDelete: 'delete',
		onCopy: 'copy',
		onMove: 'move',
	}),
	connect(mapStateToPropsFactory, {}),
)(LocationWithTypeActions);
